import { HoldingClass, Transaction, Society } from 'types';

type GetTransactionNominalValueProps = {
  holdingClass: HoldingClass | null;
  transaction: Transaction;
  society: Society;
};

/**
 * Returns the nominal value from the first available source in this priority order:
 * 1. Holding class nominal value
 * 2. Transaction nominal value
 * 3. Society nominal value
 * 4. Default to 0 if none of the above are available
 */
export const getTransactionNominalValue = ({
  holdingClass,
  transaction,
  society,
}: GetTransactionNominalValueProps): number =>
  holdingClass?.nominalValue ??
  transaction?.nominalValue ??
  society?.nominalValue ??
  0;
